import camelcaseKeys from 'camelcase-keys'
import { io } from 'socket.io-client'

import socketEntityChangementListener from '@infrastructure/entityChangement/socketEntityChangementListener'

import socketHelpers from './service/socketHelpers'

const apiSocket = io(socketHelpers.apiSocketUrl, {
  transports: ['websocket'],
  withCredentials: true,
  autoConnect: false
})

apiSocket.on('connect_error', (err) => {
  console.error(err)
  if (err.name === 'UnauthorizedError') {
    apiSocket.connect()
  }
})

apiSocket.on('entity_change', (...args) =>
  socketEntityChangementListener(...camelcaseKeys(args, { deep: true }))
)

export default apiSocket
